// extracted by mini-css-extract-plugin
export var list = "program-benefits-list-module--list--rbQzL";